module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content block-content-full"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "visible-xs push-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modal-create-inspector"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" New Forester\n    \t\t\t\t\t\t\t")])])])])])])]), _vm._v(" "), _c('div', {
    class: [(_vm.working) ? 'block-opt-refresh' : '', 'block', 'block-rounded']
  }, [_c('div', {
    staticClass: "block-content",
    staticStyle: {
      "min-height": "300px"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-vcenter table-clickable-rows"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Phone")]), _vm._v(" "), _c('th', [_vm._v("Region")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.inspectors), function(inspector) {
    return _c('tr', {
      on: {
        "click": function($event) {
          _vm.onRowClick($event.target, inspector)
        }
      }
    }, [_c('td', [_c('i', {
      staticClass: "icon-user text-muted"
    })]), _vm._v(" "), _c('td', {
      staticClass: "font-w600"
    }, [_c('router-link', {
      attrs: {
        "to": 'foresters/' + inspector.id
      }
    }, [_vm._v(_vm._s(inspector.user.contact.first_name) + " " + _vm._s(inspector.user.contact.last_name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(inspector.user.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(inspector.user.contact.phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(inspector.user.contact.region.name))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(inspector.enabled) ? _c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.onInspectorDisable(inspector)
        }
      }
    }, [_vm._v("\n    \t\t\t\t\t\t\t\t\tDisable\n    \t\t\t\t\t\t\t\t")]) : _c('button', {
      staticClass: "btn btn-xs btn-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.onInspectorEnable(inspector)
        }
      }
    }, [_vm._v("\n    \t\t\t\t\t\t\t\t\tEnable\n    \t\t\t\t\t\t\t\t")])])])
  }))])])])]), _vm._v(" "), _c('inspector-create-modal', {
    on: {
      "created": _vm.getInspectors
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64118162"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/foresters.vue
// module id = 822
// module chunks = 3